import { render } from "./ChatMessageSources.vue?vue&type=template&id=012b353e&scoped=true"
import script from "./ChatMessageSources.vue?vue&type=script&lang=js"
export * from "./ChatMessageSources.vue?vue&type=script&lang=js"

import "./ChatMessageSources.vue?vue&type=style&index=0&id=012b353e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012b353e"]])

export default __exports__